export const heroContent = {
  title: "Острів Кави",
  subtitle: "Смачна кава та затишна атмосфера",
};

export const menuCategoriesContent = {
  sectionTitle: "Меню",
  categories: [
    {
      id: "drinks",
      icon: "☕",
      title: "Напої",
      description: "",
    },
    {
      id: "desserts",
      icon: "🧁",
      title: "Десерти",
      description: "",
    },
  ],
};

export const footerContent = {
  address: "вул. Гетьмана Сагайдачного 59-A, \n поверх 2\n Масив \n м. Васильків",
  phone: "+38 (099) 738-79-51",
  email: "ostrivkavy@gmail.com",
  mapLink: "https://maps.app.goo.gl/FPkZiqzicXqDKg6B6",
  socialLinks: { 
    instagram: "https://www.instagram.com/ostriv_kavy" 
  },
  companyName: "Острів Кави",
  workingHours: "Пн-Нд: 10:00 - 22:00",
};

// Напої
export const drinksData = {
  pageTitle: "Напої",
  categories: [
    {
      id: "coffee",
      title: "Гаряча кава",
      items: [
        {
          id: "espresso",
          name: "Еспресо/Лунго",
          price: "40 ₴",
          description: "Класичний італійський еспресо",
          image: "/espresso.jpg",
          isHot: true
        },
        {
          id: "doppio",
          name: "Допіо",
          price: "64 ₴", 
          description: "Подвійна порція класичного еспресо",
          image: "/doppio.jpg",
          isHot: true
        },
        {
          id: "americano",
          name: "Американо",
          price: "40 ₴",
          description: "",
          image: "/americano.jpg",
          isHot: true
        },
        {
          id: "filter-coffee",
          name: "Фільтр-кава",
          price: "60 ₴", 
          description: "Альтернативний спосіб заварювання",
          image: "/filter-coffee.jpg",
          isHot: true
        },
        {
          id: "latte",
          name: "Лате",
          price: "60/70 ₴",
          description: "",
          image: "/latte.jpg",
          isHot: true
        },
        {
          id: "cappuccino",
          name: "Капучино",
          price: "65/80 ₴",
          description: "",
          image: "/cappuccino.jpg",
          isHot: true
        },
        {
          id: "flat-white",
          name: "Флет уайт",
          price: "70 ₴",
          description: "",
          image: "/flat-white.jpg",
          isHot: true
        },
        {
          id: "capu-orange",
          name: "Капуоранж",
          price: "60/65 ₴",
          description: "",
          image: "/capu-orange.jpg",
          isHot: true
        },
      ]
    },
    {
      id: "specialty-coffee",
      title: "Авторська кава",
      items: [
        {
          id: "pumpkin-spice",
          name: "Пряне гарбузове лате",
          price: "85/95 ₴", 
          description: "Сезонний напій з ароматом гарбуза та спецій",
          image: "/pumpkin-spice.jpg",
          isHot: true
        },
        {
          id: "caramel-latte",
          name: "Лате кранч-карамель",
          price: "85/95 ₴",
          description: "Хрустка нота карамелі",
          image: "/caramel-latte.jpg",
          isHot: true
        },
        {
          id: "milky-way-cappuccino",
          name: "Milky Way капучино",
          price: "80/90 ₴", 
          description: "Трохи кориці та згущеного молока",
          image: "/milky-way.jpg",
          isHot: true
        },
        {
          id: "lavender-cappuccino",
          name: "Лавандове капучино",
          price: "70/80 ₴",
          description: "Капучино з легкою ноткою лаванди",
          image: "/lavender-cappuccino.jpg",
          isHot: true
        },
        {
          id: "lavender-latte",
          name: "Лавандове лате",
          price: "70/80 ₴",
          description: "Лате з насиченим смаком лаванди",
          image: "/lavander-latte.jpg",
          isHot: true
        }
      ]
    },
    {
      id: "raf-coffee",
      title: "Раф",
      items: [
        {
          id: "classic-raf",
          name: "Раф класичний",
          price: "75/80 ₴",
          description: "Еспресо, вершки та нотка ванілі",
          image: "/classic-raf.jpg",
          isHot: true
        },
        {
          id: "honey-raf",
          name: "Медовий раф",
          price: "80/90 ₴",
          description: "Раф з натуральним медом",
          image: "/src/assets/drinks/honey-raf.jpg",
          isHot: true
        },
        {
          id: "halva-raf",
          name: "Халвовий раф",
          price: "80/90 ₴",
          description: "Раф з ноткою східних солодощів",
          image: "/halva-raf.jpg",
          isHot: true
        },
        {
          id: "hazelnut-raf",
          name: "Грильʼяжний раф",
          price: "80/90 ₴",
          description: "Раф з горіховим присмаком",
          image: "/hazelnut-raf.jpg",
          isHot: true
        }
      ]
    },
    {
      id: "matcha",
      title: "Матча",
      items: [
        {
          id: "matcha-shot",
          name: "Матча шот",
          price: "50 ₴",
          description: "Концентрований напій з японського зеленого чаю",
          image: "/matcha-shot.jpg",
          isHot: true
        },
        {
          id: "matcha-latte",
          name: "Матча лате",
          price: "70/80 ₴",
          description: "",
          image: "/matcha-latte.jpg",
          isHot: true
        },
        {
          id: "iced-matcha",
          name: "Айс-матча",
          price: "85 ₴",
          description: "",
          image: "/ice-matcha.jpg",
          isHot: false
        },
        {
          id: "matcha-orange",
          name: "Матча оранж",
          price: "100 ₴",
          description: "Матча з апельсиновим соком",
          image: "/matcha-orange.jpg",
          isHot: false
        }
      ]
    },
    {
      id: "cold-drinks", 
      title: "Холодні напої",
      items: [
        {
          id: "iced-latte",
          name: "Айс-лате",
          price: "70 ₴",
          description: "",
          image: "/ice-latte.jpg",
          isHot: false
        },
        {
          id: "espresso-tonic",
          name: "Еспресо-тонік",
          price: "100 ₴",
          description: "",
          image: "/src/assets/drinks/espresso-tonic.jpg",
          isHot: false
        },
        {
          id: "frappe",
          name: "Фрапе",
          price: "100 ₴",
          description: "Молочний коктейль + кава",
          image: "/frappe.jpg",
          isHot: false
        },
        {
          id: "milk-cocktail",
          name: "Молочний коктейль",
          price: "90 ₴",
          description: "",
          image: "/milkshake.jpg",
          isHot: false,
          tags: ["+ сироп на вибір"]
        },
        {
          id: "bubble-milk",
          name: "Bubble milk",
          price: "105 ₴",
          description: "Молочний напій + bubble tea",
          image: "/bubble-milk.jpg",
          isHot: false
        },
        {
          id: "cold-cocoa",
          name: "Холодне какао",
          price: "80 ₴",
          description: "",
          image: "/src/assets/drinks/cold-cocoa.jpg",
          isHot: false
        },
        {
          id: "orange",
          name: "Оранж",
          price: "100 ₴",
          description: "Холодна кава з апельсиновим соком",
          image: "/orange.jpg",
          isHot: false,
          tags: ["+ сироп сол. карамель"]
        },
        {
          id: "pomegranate",
          name: "Гранат",
          price: "105 ₴",
          description: "Холодна кава + гранатовий сік",
          image: "/pomegranate.jpg",
          isHot: false,
          tags: ["+ сироп сол. карамель"]
        },
        {
          id: "pineapple",
          name: "Ананас",
          price: "105 ₴",
          description: "Холодна кава + ананасовий сік",
          image: "/pineapple.jpg",
          isHot: false,
          tags: ["+ сироп сол. карамель"]
        },
        {
          id: "cherry",
          name: "Вишня",
          price: "100 ₴",
          description: "Холодна кава + вишневий сік",
          image: "/src/assets/drinks/cherry.jpg",
          isHot: false
        },
        {
          id: "mojito",
          name: "Мохіто",
          price: "80 ₴",
          description: "Безалкогольний мохіто з м'ятою",
          image: "/mojito.jpg",
          isHot: false
        },
        {
          id: "aperol",
          name: "Шприц-апероль",
          price: "85 ₴",
          description: "Безалкогольний напій з апельсиновим смаком",
          image: "/aperol.jpg",
          isHot: false
        },
        {
          id: "glase",
          name: "Глясе",
          price: "65 ₴",
          description: "Кулька морозива + еспресо",
          image: "/glase.jpg",
          isHot: false
        }
      ]
    },
    {
      id: "warming-tea",
      title: "Зігріваючий чай",
      items: [
        {
          id: "natural-tea",
          name: "Чай органічний",
          price: "55 ₴",
          description: "",
          image: "/natural-tea.jpg",
          isHot: true,
          tags: ["B асортименті"]
        },
        {
          id: "puer",
          name: "Шу пуер",
          price: "70 ₴",
          description: "Міцний китайський чорний чай",
          image: "/puer.jpg",
          isHot: true
        },
        {
          id: "tea-assortment",
          name: "Чай в асортименті",
          price: "45 ₴",
          description: "",
          image: "/tea-assortment.jpg",
          isHot: true
        }
      ]
    },
    {
      id: "vitamin-tea",
      title: "Вітамінний чай",
      items: [
        {
          id: "vitamin-tea",
          name: "Вітамінний чай",
          price: "60 ₴",
          description: "Корисний чай з вітамінними добавками",
          image: "/vitamin-tea.jpg",
          isHot: true,
          tags: ["B асортименті"]
        },
        {
          id: "lemonade-tea",
          name: "Вітамінний лимонад",
          price: "75 ₴",
          description: "Освіжаючий чай-лимонад",
          image: "/lemonade-tea.jpg",
          isHot: false,
          tags: ["B асортименті"]
        },
        {
          id: "bubble-lemonade",
          name: "Bubble лимонад",
          price: "90 ₴",
          description: "Лимонад з bubble tea",
          image: "/src/assets/drinks/bubble-lemonade.jpg",
          isHot: false
        }
      ]
    },
    {
      id: "other-drinks",
      title: "Інші напої",
      items: [
        {
          id: "cocoa",
          name: "Какао",
          price: "60/70 ₴",
          description: "",
          image: "/cocoa.jpg",
          isHot: true
        },
        {
          id: "hot-chocolate",
          name: "Гарячий шоколад",
          price: "75/85 ₴",
          description: "",
          image: "/src/assets/drinks/hot-chocolate.jpg",
          isHot: true
        },
        {
          id: "mexican-hot-chocolate",
          name: "Мексиканський гарячий шоколад",
          price: "80/100 ₴",
          description: "Пряний гарячий шоколад з нотками спецій",
          image: "/mexican-chocolate.jpg",
          isHot: true
        },
        {
          id: "coffee-latte",
          name: "Бейбі лате",
          price: "40/50 ₴",
          description: "Збите молоко + сироп",
          image: "/src/assets/drinks/coffee-latte.jpg",
          isHot: true,
          tags: ["+ Сироп в асортименті"]
        }
      ]
    },
    {
      id: "addons",
      title: "Додатки",
      items: [
        {
          id: "syrup",
          name: "Сироп/Топінг",
          price: "+15 ₴",
          description: "",
          image: "/syrup.jpg"
        },
        {
          id: "condensed-milk",
          name: "Згущене молоко", 
          price: "25 ₴",
          description: "",
          image: "/condensed-milk.jpg"
        },
        {
          id: "regular-milk",
          name: "Молоко",
          price: "+15 ₴",
          description: "",
          image: "/milk.jpg"
        },
        {
          id: "lactose-free-milk",
          name: "Безлактозне молоко",
          price: "+20 ₴",
          description: "",
          image: "/lactose-free-milk.jpg"
        },
        {
          id: "plant-milk",
          name: "Рослинне молоко",
          price: "+30 ₴",
          description: "",
          image: "/plant-milk.jpg"
        },
        {
          id: "marshmallow",
          name: "Маршмелоу",
          price: "+20 ₴",
          description: "",
          image: "/marshmallow.jpg"
        },
        {
          id: "whipped-cream",
          name: "Аерозольні вершки",
          price: "+20 ₴", 
          description: "",
          image: "/whipped-cream.jpg"
        },
        {
          id: "decaf",
          name: "Декафеїнато",
          price: "+10 ₴",
          description: "Кава без кофеїну",
          image: "/decaf.jpg"
        },
        {
          id: "shimmer",
          name: "Харчовий шиммер",
          price: "+20 ₴",
          description: "Додає напою неймовірний перламутровий блиск",
          image: "/shimmer.jpg"
        }
      ]
    }
  ]
};

// Десерти
export const dessertsData = {
  pageTitle: "Десерти",
  categories: [
    {
      id: "desserts",
      title: "Десерти",
      items: [
        {
          id: "macaroon",
          name: "Макарон",
          price: "75 ₴",
          description: "Класичний французький макарон на мигдалевому борошні",
          image: "/macaroon.jpg"
        },
        {
          id: "nut",
          name: "Горішок",
          price: "35 ₴",
          description: "Пісочне печиво y формі горішка з начинкою",
          image: "/nut.jpg",
          tags: ["Згущене молоко", "Солона карамель", "Вишня в шоколаді", "Фісташка & Малина"]
        },
        {
          id: "tube",
          name: "Трубочка",
          price: "50 ₴",
          description: "Хрустка вафельна трубочка з начинкою",
          image: "/tube.jpg",
          tags: ["Згущене молоко", "Солона карамель", "Вишня в шоколаді", "Фісташка & Малина"]
        },
        {
          id: "new-york",
          name: "Нью-Йорк рол",
          price: "75 ₴",
          description: "Хрусткий десерт з листкового тіста з начинкою",
          image: "/new-york.jpg",
          tags: ["B асортименті"]
        },
        {
          id: "muffin",
          name: "Мафін",
          price: "55 ₴",
          description: "Ароматний кекс на вибір з різними смаками",
          image: "/muffin.jpg",
          tags: ["B асортименті"]
        }
      ]
    },
    {
      id: "ice-cream",
      title: "Морозиво",
      items: [
        {
          id: "ice-cream-img",
          name: "Морозиво",
          price: "55 ₴",
          description: "Одна кулька y вафельному ріжку",
          image: "/ice-cream.jpg"
        }
      ]
    }
  ]
};
